// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_wrapper__u0wIH {
    font-size: 20px ;
    padding: 8px ;
    height: 49px ;
    border: 1px solid black ;
    border-radius: 2px ;
}`, "",{"version":3,"sources":["webpack://./src/components/Input/Input.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,wBAAwB;IACxB,mBAAmB;AACvB","sourcesContent":[".wrapper {\r\n    font-size: 20px ;\r\n    padding: 8px ;\r\n    height: 49px ;\r\n    border: 1px solid black ;\r\n    border-radius: 2px ;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Input_wrapper__u0wIH`
};
export default ___CSS_LOADER_EXPORT___;
